export enum Authority {
    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_USER = 'ROLE_USER',
    ROLE_REFERENTE_ENTE = 'ROLE_REFERENTE_ENTE'
}